module.exports = __webpack_public_path__ + "img/mgh-kyobashi.ee20fb1f.jpg";